module.exports = __webpack_public_path__ + "img/1f33b.9118591.svg";